import { useBunja } from 'bunja/react';
import { useAtom } from 'jotai';
import { useTranslations } from 'next-intl';
import { ChangeEventHandler } from 'react';

import { css } from '@flipster/styled-system/css';
import { inputFormatter } from '@flipster/utils/num';
import segment from '@flipster/utils/segment';
import { PositionEvent } from '@flipster/utils/segment/events/position';

import { adjustLeverageModalBunja } from '../state';

interface LeverageInputProps {
  max: number;
  symbol: string;
}

export const LeverageInput = ({ max, symbol }: LeverageInputProps) => {
  const t = useTranslations();

  const { leverageAtom } = useBunja(adjustLeverageModalBunja);
  const [leverage, setLeverage] = useAtom(leverageAtom);

  const onChangeInput: ChangeEventHandler<HTMLInputElement> = (e) => {
    const { value: leverage } = e.currentTarget;

    const newLeverage = Number(inputFormatter(leverage, { withComma: false }));

    const appliedleverage = newLeverage === 0 ? 1 : newLeverage > max ? max : newLeverage;
    setLeverage(appliedleverage);

    segment.track(PositionEvent.AdjustLeverageKeyboardClick, { symbol, adjust_leverage: appliedleverage });
  };

  return (
    <>
      <input
        type='text'
        placeholder={t('Autogen_common.r251126.s_input')}
        value={leverage}
        onChange={onChangeInput}
        className={css({
          position: 'absolute',
          font: 'inherit',
          bg: 'transparent',
          color: 'transparent',
          caretColor: 'background.accent.primary',
          left: 0,
          right: 0,
        })}
      />
      <span className={css({ color: 'content.default.level-5' })}>{leverage}x</span>
    </>
  );
};
